import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ButtonRequest from '../Forms/ButtonRequest';
import Head from '../Helper/Head';
import styles from './User.module.css';
// import { ReactComponent as ListarPdvs } from '../../Assets/pdv.svg';
// import { ReactComponent as ListarUsuarios } from '../../Assets/app.svg';
import { ReactComponent as GerarCsv } from '../../Assets/csv.svg';
import { ReactComponent as HistoricoDeEstacionamento } from '../../Assets/parking.svg';
// import { ReactComponent as AdicionarCads } from '../../Assets/cad.svg';

const User = () => {
  return (
    <section className="container">
      <header className={styles.header}>
        <h1 className="title">Relatórios ZAD</h1>
      </header>
      <Head title="Usuário" />
      <Routes>
        {/* <Route path="/pdvs" element={<ListarPdvs />} />
        <Route path="/users" element={<ListarUsuarios />} /> */}
        <Route path="/gerarCsv" element={<GerarCsv />} />
        <Route
          path="/historicoDeEstacionamento"
          element={<HistoricoDeEstacionamento />}
        />
      </Routes>
      <ul className={styles.grid}>
        <li>
          <ButtonRequest to="/admin/gerarCsv">
            <GerarCsv className={styles.icon} />
            Gerar CSV para Notas Fiscais
          </ButtonRequest>
        </li>
        <li>
          <ButtonRequest to="/admin/historicoDeEstacionamento">
            <HistoricoDeEstacionamento className={styles.icon} />
            Histórico De Estacionamento
          </ButtonRequest>
        </li>
        {/* <li>
          <ButtonRequest to="/admin/users">
            <ListarUsuarios className={styles.icon} />
            Listar Usuários
          </ButtonRequest>
        </li>
        <li>
          <ButtonRequest to="/admin/pdvs">
            <ListarPdvs className={styles.icon} />
            Listar PDVs
          </ButtonRequest>
        </li> */}
        {/* <li>
          <ButtonRequest to="/admin/addCADs">
            <AdicionarCads className={styles.icon} />
            Adicionar CADs
          </ButtonRequest>
        </li> */}
      </ul>
    </section>
  );
};

export default User;
